import { Stack } from "@mui/material";
import React from "react";
import { RichTextField } from "../ConfigFields/RichTextField";
import { StringField } from "../ConfigFields/StringField";

const RichTextMessagePreset = ({ schema, config, handleConfigChange }) => {
  return (
    <Stack spacing={3}>
      <RichTextField
        fieldKey="message"
        schema={schema?.properties["message"] || {}}
        value={config["message"]}
        required={true}
        onChange={(val) => handleConfigChange("message", val)}
      />

      <StringField
        fieldKey="header"
        schema={schema?.properties["header"] || {}}
        value={config["header"]}
        required={false}
        onChange={(val) => handleConfigChange("header", val)}
      />

      <StringField
        fieldKey="footer"
        schema={schema?.properties["footer"] || {}}
        value={config["footer"]}
        required={false}
        onChange={(val) => handleConfigChange("footer", val)}
      />
    </Stack>
  );
};

export default RichTextMessagePreset;
